export default "__VITE_ASSET__YN5LNcwa__"